// Layout zone configurations for the offer-page builder.
// Extracted from OfferPageBuilderSimple.js. Each key is a LAYOUT_TYPES value.

import { LAYOUT_TYPES } from './offerElementTypes';

export const LAYOUT_CONFIGS = {
  [LAYOUT_TYPES.SINGLE]: {
    name: 'Single Column',
    description: 'One full-width column',
    zones: [{ id: 'zone-1', width: '100%' }]
  },
  [LAYOUT_TYPES.SINGLE_ROW_2]: {
    name: '2 Columns',
    description: 'Horizontal row with 2 equal columns',
    zones: [
      { id: 'zone-1', width: '50%' },
      { id: 'zone-2', width: '50%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_3]: {
    name: '3 Columns',
    description: 'Horizontal row with 3 equal columns',
    zones: [
      { id: 'zone-1', width: '33.33%' },
      { id: 'zone-2', width: '33.33%' },
      { id: 'zone-3', width: '33.33%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_4]: {
    name: '4 Columns',
    description: 'Horizontal row with 4 equal columns',
    zones: [
      { id: 'zone-1', width: '25%' },
      { id: 'zone-2', width: '25%' },
      { id: 'zone-3', width: '25%' },
      { id: 'zone-4', width: '25%' }
    ]
  },
  [LAYOUT_TYPES.SINGLE_ROW_5]: {
    name: '5 Columns',
    description: 'Horizontal row with 5 equal columns',
    zones: [
      { id: 'zone-1', width: '20%' },
      { id: 'zone-2', width: '20%' },
      { id: 'zone-3', width: '20%' },
      { id: 'zone-4', width: '20%' },
      { id: 'zone-5', width: '20%' }
    ]
  },
  [LAYOUT_TYPES.TWO_COLUMN]: {
    name: 'Two Columns',
    description: 'Side by side columns',
    zones: [
      { id: 'zone-1', width: '50%' },
      { id: 'zone-2', width: '50%' }
    ]
  },
  [LAYOUT_TYPES.THREE_COLUMN]: {
    name: 'Three Columns',
    description: 'Three equal columns',
    zones: [
      { id: 'zone-1', width: '33.33%' },
      { id: 'zone-2', width: '33.33%' },
      { id: 'zone-3', width: '33.33%' }
    ]
  },
  [LAYOUT_TYPES.HERO]: {
    name: 'Hero Section',
    description: 'Large header with content below',
    zones: [
      { id: 'zone-1', width: '100%', height: '200px' },
      { id: 'zone-2', width: '100%' }
    ]
  },
  [LAYOUT_TYPES.FEATURE]: {
    name: 'Feature Layout',
    description: 'Image left, content right',
    zones: [
      { id: 'zone-1', width: '40%' },
      { id: 'zone-2', width: '60%' }
    ]
  },
  [LAYOUT_TYPES.CTA]: {
    name: 'Call to Action',
    description: 'Centered content with action',
    zones: [
      { id: 'zone-1', width: '100%', textAlign: 'center' }
    ]
  },
  [LAYOUT_TYPES.INLINE_ROW]: {
    name: 'Inline Row',
    description: 'Flexible row with adjustable element positions',
    zones: [
      { id: 'inline-zone-1', width: 'auto', position: 'relative', display: 'flex', alignItems: 'center', gap: '10px' }
    ]
  }
};
